const TV_URL = process.env.REACT_APP_TV_URL;
const SOCIAL_URL = process.env.REACT_APP_SOCIAL_URL;
const MUSIC_URL = process.env.REACT_APP_MUSIC_URL;
const EVENT_URL = process.env.REACT_APP_EVENT_URL;
const CLASSES_URL = process.env.REACT_APP_CLASSES_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


export { TV_URL, SOCIAL_URL, MUSIC_URL, EVENT_URL, CLASSES_URL,BASE_URL };
